import { render, staticRenderFns } from "./EvaluationPerformanceGravityPage.vue?vue&type=template&id=4bb1a3d8&"
import script from "./EvaluationPerformanceGravityPage.vue?vue&type=script&lang=js&"
export * from "./EvaluationPerformanceGravityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports